import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';

import leaderboardUiReducer from './leaderboardUiReducer';
import leaderboardDataReducer from './leaderboardDataReducer';

// const authDataPersistConfig = {
//   key: 'data',
//   storage,
//   stateReconciler: hardSet,
// };

export default combineReducers({
  ui: leaderboardUiReducer,
  data: leaderboardDataReducer,
});
